module.exports = __webpack_public_path__ + "img/wysjfw2.ec5215da.png";